import React from "react"
import { Card, CardProps } from "react-bootstrap"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { ProjectModel } from "features/project-management/types/ProjectModel"

import { ProjectCardContext } from "./ProjectCardContext"
import "./styles/_project-card.scss"
import { ProjectCardActions } from "./ui/ProjectCardActions"
import { ProjectCardBody } from "./ui/ProjectCardBody"
import { ProjectCardChips } from "./ui/ProjectCardChips"
import { ProjectCardDivider } from "./ui/ProjectCardDivider"
import { ProjectCardHeader } from "./ui/ProjectCardHeader"
import { ProjectCardImage } from "./ui/ProjectCardImage"
import { ProjectCardRow } from "./ui/ProjectCardRow"
import { ProjectCardTitle } from "./ui/ProjectCardTitle"

export interface ProjectCardRootProps
  extends WithClassName,
    Omit<CardProps, "text" | "onSubmit"> {
  model?: ProjectModel | null
  isLoading?: boolean
}

const ProjectCardRoot = React.memo(
  React.forwardRef<HTMLElement, ProjectCardRootProps>(
    (
      { model, isLoading: isLoadingProp = false, className, children, ...rest },
      ref
    ) => {
      const isLoading = model?.core.data.project?.isLoading || isLoadingProp

      const cardClassName = classNames("project-card", className, {
        "project-card--loading": isLoading,
        "project-card--team-project": !!model?.core.data.project?.data?.team?.id
      })

      const contextValue = React.useMemo(
        () => ({ model: model ?? null, isLoading }),
        [model, isLoading]
      )

      return (
        <ProjectCardContext.Provider value={contextValue}>
          <Card
            ref={ref}
            className={cardClassName}
            data-testid="project-card"
            {...rest}
          >
            {children}
          </Card>
        </ProjectCardContext.Provider>
      )
    }
  )
)

export const ProjectCard = Object.assign(ProjectCardRoot, {
  Image: ProjectCardImage,
  Body: ProjectCardBody,
  Row: ProjectCardRow,
  Divider: ProjectCardDivider,
  Header: ProjectCardHeader,
  Chips: ProjectCardChips,
  Actions: ProjectCardActions,
  Title: ProjectCardTitle
})
